import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { assertVueComponent } from '../helpers';
export class ToastMessageAction extends ba.Action {
    static get manifest() {
        return {
            name: 'toastMessage',
            schema: z.object({
                message: z.union([z.string(), SCRIPT_SCHEMA()]),
                title: z.union([z.string(), SCRIPT_SCHEMA()]).optional(),
                variant: z.union([z.string(), SCRIPT_SCHEMA()]).optional()
            })
        };
    }
    async handle(event, args) {
        assertVueComponent(event.component);
        event.component.$root.$notification.show(args);
    }
}
export class NotificationAction extends ba.Action {
    static get manifest() {
        return {
            name: 'notification',
            schema: z.object({
                message: z.union([z.string(), SCRIPT_SCHEMA()]),
                title: z.union([z.string(), SCRIPT_SCHEMA()]).optional(),
                variant: z.union([z.string(), SCRIPT_SCHEMA()]).optional()
            })
        };
    }
    async handle(event, args) {
        assertVueComponent(event.component);
        event.component.$root.$notification.show(args);
    }
}
//# sourceMappingURL=notifications.js.map